import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseSplitPaymentOnNonDomesticPurchaseError extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.purchase.validation.split-payment-on-non-domestic-purchase-error.message');
    }
}
